import React from 'react';

import { CardProps } from 'antd/lib/card';

import * as Styled from './Card.style';

export type Props = CardProps;

export const Card = (props: Props): JSX.Element => <Styled.Card {...props} />;
